export enum DaysOfWeekEnum {
	Sunday = '217b6919-0c91-49d4-9398-3974f0dbbaf0',
	Monday = '58a25094-21c0-4cfc-b920-a3896a24ec95',
	Tuesday = 'a3d54a2c-fa49-4ced-9488-0b311a83702b',
	Wednesday = '7c1613db-e4a2-4075-b24f-f96ca5105b38',
	Thursday = '6e042c2d-b66a-4e4b-a463-088da7d86373',
	Friday = '131d6f1d-9bd0-440a-8f81-79c4204a3700',
	Saturday = '52f37fa9-f1ce-4746-86c9-72e8d39f3408',
}
